var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediumPriority(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66602 1.99998L6.83268 0.333313H0.166016V14.5H1.83268V8.66665H5.99935L6.83268 10.3333H12.666V1.99998H7.66602Z",
    fill: "#EFD963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumPriority);
export default __webpack_public_path__ + "static/media/mediumPriority.ea273ed9e8d38cea202ac3e6107c43f3.svg";
export { ForwardRef as ReactComponent };